<template>
	<div class="presale-search-body">
		<div class="filters-box-row" :style="collapse ? 'height: 50px' : ''">
			<div class="filters-container">
				<div class="input-box">
					<span>活动编号：</span>
					<el-input
						class="search-input"
						v-model="code"
						placeholder="请输入活动编号"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>活动名称：</span>
					<el-input
						class="search-input"
						v-model="name"
						placeholder="请输入活动名称"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<!-- <div class="filters-container">
				<div class="input-box">
					<span>预售状态：</span>
					<el-select v-model="discountState" size='small'>
						<el-option :value="-1" label="全部"></el-option>
						<el-option :value="1" label="未开始"></el-option>
						<el-option :value="0" label="进行中"></el-option>
						<el-option :value="2" label="已结束"></el-option>
					</el-select>
				</div>
			</div> -->
			<div class="filters-container" style="margin-right: 20px">
				<div class="input-box">
					<span>活动状态：</span>
					<el-select v-model="disabledFlag" clearable size='small' class="search-input">
						<el-option :value="-1" label="全部"></el-option>
						<el-option :value="0" label="启用"></el-option>
						<el-option :value="1" label="停用"></el-option>
					</el-select>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>活动起止时间：</span>
					<el-date-picker
						v-model="dateValue"
						:clearable="false"
						:unlink-panels='true'
						class="time-input"
						size="small"
						type="datetimerange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:default-time="['00:00:00', '23:59:59']"
						format='yyyy-MM-dd HH:mm:ss'
						value-format='yyyy-MM-dd HH:mm:ss'>
					</el-date-picker>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>预计发货时间：</span>
					<el-date-picker
						v-model="dateValue1"
						:clearable="false"
						:unlink-panels='true'
						class="time-input"
						size="small"
						type="datetimerange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:default-time="['00:00:00', '23:59:59']"
						format='yyyy-MM-dd HH:mm:ss'
						value-format='yyyy-MM-dd HH:mm:ss'>
					</el-date-picker>
				</div>
			</div>
		</div>
		<div class="presale-search-btn">
			<el-button size="small" type="text" class="btn" style="color:#333;margin-left:10px" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:#AFB1B3;"/>
			</el-button>
			<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
			<el-button size="small" plain class="btn fx-btn" style="margin-left: 10px" @click="clear">清空</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'search',
	data () {
		return {
			collapse: false,
			dateValue: [],
			dateValue1: [],
			code: '',
			name: '',
			discountState: -1,
			disabledFlag: -1
		}
	},
	methods: {
		handleCollapse () {
			this.collapse = !this.collapse
		},
		search () {
			let params = {
				dateValue: this.dateValue,
				dateValue1: this.dateValue1,
				code: this.code,
				name: this.name,
				discountState: this.discountState,
				disabledFlag: this.disabledFlag
			}
			this.$emit('handleSearch', params)
		},
		clear () {
			this.clearAllInput()
			this.search()
		},
		clearAllInput () {
			this.dateValue = []
			this.dateValue1 = []
			this.code = ''
			this.name = ''
			this.discountState = -1
			this.disabledFlag = -1
		}
	}
}
</script>

<style lang="stylus" scoped>
.presale-search-body {
	display: flex;
	justify-content: space-between
	padding: 10px 0 0 0;
	width :100%;
	line-height :50px;
}
.presale-search-btn {
	width: 200px;
	flex-shrink: 0
}
.filters-box-row {
	display: flex;
	flex-wrap: wrap;
	overflow: hidden
	box-sizing: border-box
	text-align: left
	.filters-container {
		margin-right: 5px
		.input-box>span {
			display: inline-block;
			width: 85px;
			text-align: right
		}
		.search-input {
			width: 155px
		}
	}
}
</style>
<style lang="stylus">
	.export-btn {
		span {
			display: flex;
			align-items: center
			div {
				width: 14px;
				height: 14px;
				margin-right: 5px;
				background-image: url('~images/icon/export-icon.png')
			}
		}
		&:hover {
			div {
				background-image: url('~images/icon/export-white-icon.png')
			}
		}
	}
	.input-tel input{
		-webkit-appearance: none;
		-webkit-box-sizing: content-box;
		font-family: inherit;
		font-size: 100%;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
	.confirm-dialog {
		text-align left
		.errormsgText{
			width:100%;
			text-align :left
			line-height:30px;
		}
	}
</style>
